<template>
  <div>
    <router-link :to="href" class="u-color--blue link link-info popin" event="" @click.native="clicked($event)">
      <img src="@/assets/img/icons.svg#icon-infos" width="16" height="16">
      {{nameLink}}
    </router-link>

    <modal-infos v-show="isModalVisible"
                 @close="closeModal"
                 :text="contents"
                 v-if="Object.keys(contents).length && contents['edges'].length"
    />
  </div>

</template>

<script>
  import ModalInfos from "../../Modal/Models/Modal-infos";
  import gql from 'graphql-tag'

  export default {
    name: "LinkInfo",
    components: {ModalInfos},
    props: ['nameLink', 'href'],
    apollo: {
      contents: {
        query: gql` query contents($slug: String) {
          contents(slug: $slug) {
              edges {
                node {
                      title,
                      body,
                      slug
                    }
                }
            }
        }`,
        variables() {
          // Use vue reactive properties here
          return {
            slug: this.slug
          }
        }
      }
    },
    data () {
      return {
        isModalVisible: false,
        contents: {},
        slug: ''
      };
    },
    methods: {
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      },
      clicked(event) {
        this.slug = this.href.substring(this.href.lastIndexOf("/") + 1)
        this.showModal()
      }
    }
  }
</script>

<style lang="scss">
  .link-info {
    cursor: pointer;

    img {
      margin-right: rem(5px);
    }
  }
</style>